import { Box, Grid, Paper, Skeleton } from "@mui/material";

export default function DetailFormSkeleton() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <Box key={i} sx={{ mb: 2.5 }}>
              <Skeleton variant="text" width="40%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="rounded" height={40} />
            </Box>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={12} md={8}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, minHeight: 400 }}>
          <Skeleton variant="text" width={180} height={28} sx={{ mb: 2 }} />
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={80} sx={{ mb: 2 }} />
          ))}
        </Paper>
      </Grid>
    </Grid>
  );
}
